<p-dialog
  p-dialog
  appendTo="body"
  header="{{ 'ReceivingInstruction.DetailTable.BatchUpdate' | translate }}"
  [style]="{width: '70vw'}"
  [(visible)]="isVisible"
  (onHide)="dialogVisibleChange(false)"
  (onShow)="initComponent()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true">
  <div class="mt-2">
    <div class="p-fluid formgrid grid">
        <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ReceivingInstruction.DetailTable.TaskCode' | translate }}</label>
            <div class="col-8 column-value">
            <p-multiSelect
                [filter]="true"
                placeholder="{{ 'Common.DropDown.Select' | translate }}"
                [options]="receivingTaskOptions"
                appendTo="body"
                [(ngModel)]="taskCode"
                class="p-fluid"
                optionDisabled="isDisabled"
                (onChange)="taskCodeOptionCahange()">
            </p-multiSelect>
            </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{'ReceivingInstruction.DetailTable.TaskRemark' | translate}}</label>
            <div class="col-8 column-value">
            <input
                pInputText
                type="text"
                required
                [(ngModel)]="taskRemark"
                [disabled]="!this.canEditTaskRemark"/>
            </div>
        </div>
    </div>

    <!-- 當 taskCode 為 ['N03-5'] 時顯示 TabView -->
    <p-tabView *ngIf="showModeToggle" [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
      <!-- 手動維護 Tab -->
      <p-tabPanel header="{{ 'ReceivingInstruction.BatchUpdate.ManualInput' | translate }}">
        <ng-container *ngFor="let task of advanceTaskCodeFieldType | keyvalue">
          <div class="p-fluid formgrid grid mt-2">
            <div class="field grid col-2 align-items-center">
              <label class="column-label col-12 text-center justify-content-start">{{ task.key |  optionsMapping: this.receivingTaskOptions}}</label>
            </div>
            <div class="field grid col-10 align-items-baseline" style="gap : 30px 0px">
              <ng-container *ngFor="let field of task.value | keyvalue">
                <ng-container *ngFor="let fieldType of field.value | keyvalue ">
                  <label class="col-2 column-label">{{ 'ReceivingInstruction.AdvanceTaskMaintenance.Label.' + fieldType.key | translate }}</label>
                  <div *ngIf="checkFieldType(fieldType.value,'FreeKey')" class="col-4 column-value">
                    <input
                      pInputText
                      type="text"
                      required
                      [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                    />
                    <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                      <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                    </small>
                  </div>

                  <div *ngIf="checkFieldType(fieldType.value,'DropDown')" class="col-4 column-value">
                    <p-dropdown
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [filter]="true"
                      appendTo="body"
                      class="p-fluid"
                      [itemSize]="40"
                      [virtualScroll]="checkOptionsListSize(fieldType.key)"
                      [options]="checkOptionsList(fieldType.key)"
                      [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                      (onChange)="initOption(advanceValues[assertType(task.key)][assertType('lockType')])"
                    >
                    </p-dropdown>
                    <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                      <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                    </small>
                  </div>

                  <div *ngIf="checkFieldType(fieldType.value,'MultiSelect')" class="col-4 column-value">
                    <p-multiSelect
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      appendTo="body"
                      class="p-fluid"
                      [itemSize]="40"
                      [virtualScroll]="checkOptionsListSize(fieldType.key)"
                      [options]="checkOptionsList(fieldType.key)"
                      [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                      (onChange)="initOption(advanceValues[assertType(task.key)][assertType('lockType')])"
                    >
                    </p-multiSelect>
                    <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                      <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                    </small>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </p-tabPanel>

      <!-- 上傳檔案 Tab -->
      <p-tabPanel header="{{ 'ReceivingInstruction.BatchUpdate.FileUpload' | translate }}">
        <div class="formgrid grid mt-2">
          <div class="field col-12 flex align-items-center">
            <input type="file" accept=".xlsx,.xls" (change)="onFileSelect($event)" #fileInput style="display: none"/>
            <button pButton type="button" label="{{ 'ReceivingInstruction.BatchUpdate.ChooseFile' | translate }}"
                    icon="pi pi-folder-open" class="p-button-outlined p-button-sm mr-2" (click)="fileInput.click()"></button>
            <button pButton type="button" label="{{ 'ReceivingInstruction.BatchUpdate.DownloadTemplate' | translate }}"
                    icon="pi pi-download" class="p-button-outlined p-button-sm" (click)="downloadTemplate()"></button>
            <span class="ml-3" *ngIf="selectedFileName">{{ selectedFileName }}</span>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>

    <!-- 非 N03-5 時顯示原本的表單欄位 -->
    <ng-container *ngIf="!showModeToggle">
      <ng-container *ngFor="let task of advanceTaskCodeFieldType | keyvalue">
        <div class="p-fluid formgrid grid mt-2">
          <div class="field grid col-2 align-items-center">
            <label class="column-label col-12 text-center justify-content-start">{{ task.key |  optionsMapping: this.receivingTaskOptions}}</label>
          </div>
          <div class="field grid col-10 align-items-baseline" style="gap : 30px 0px">
            <ng-container *ngFor="let field of task.value | keyvalue">
              <ng-container *ngFor="let fieldType of field.value | keyvalue ">
                <label class="col-2 column-label">{{ 'ReceivingInstruction.AdvanceTaskMaintenance.Label.' + fieldType.key | translate }}</label>
                <div *ngIf="checkFieldType(fieldType.value,'FreeKey')" class="col-4 column-value">
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                  />
                  <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                    <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                  </small>
                </div>

                <div *ngIf="checkFieldType(fieldType.value,'DropDown')" class="col-4 column-value">
                  <p-dropdown
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [filter]="true"
                    appendTo="body"
                    class="p-fluid"
                    [itemSize]="40"
                    [virtualScroll]="checkOptionsListSize(fieldType.key)"
                    [options]="checkOptionsList(fieldType.key)"
                    [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                    (onChange)="initOption(advanceValues[assertType(task.key)][assertType('lockType')])"
                  >
                  </p-dropdown>
                  <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                    <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                  </small>
                </div>

                <div *ngIf="checkFieldType(fieldType.value,'MultiSelect')" class="col-4 column-value">
                  <p-multiSelect
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    appendTo="body"
                    class="p-fluid"
                    [itemSize]="40"
                    [virtualScroll]="checkOptionsListSize(fieldType.key)"
                    [options]="checkOptionsList(fieldType.key)"
                    [(ngModel)]="advanceValues[assertType(task.key)][assertType(fieldType.key)]"
                    (onChange)="initOption(advanceValues[assertType(task.key)][assertType('lockType')])"
                  >
                  </p-multiSelect>
                  <small *ngIf="checkInvalidStates(task.key,fieldType.key)" class="errors">
                    <div class="p-invalid">{{ 'Common.Button.Required' | translate }}</div>
                  </small>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="field">
    <div class="col">
      <!-- 手動維護模式或非 N03-5 的確認按鈕 -->
      <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}"
              *ngIf="!showModeToggle || activeTabIndex === 0"
              (click)="updateReceivingInstructionClick()"></button>

      <!-- 上傳檔案模式的上傳按鈕 -->
      <button pRipple pButton label="{{ 'ReceivingInstruction.BatchUpdate.Upload' | translate }}"
              *ngIf="showModeToggle && activeTabIndex === 1"
              [loading]="isUploading"
              [disabled]="!selectedFile || isUploading"
              (click)="uploadFile()"></button>
    </div>
  </div>
</p-dialog>
